"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledDictionaryTermModalVideo = exports.StyledDictionaryTermModalTitle = exports.StyledDictionaryTermModalMedia = exports.StyledDictionaryTermModalContent = exports.StyledDictionaryTermModalContainer = exports.StyledDictionaryTermModal = exports.StyledDictionaryTermContainer = exports.StyledDictionaryTerm = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

var _default = {};
exports["default"] = _default;

var StyledDictionaryTerm = _styledComponents["default"].a.withConfig({
  displayName: "DictionaryTermsstyles__StyledDictionaryTerm",
  componentId: "sc-l9zmz5-0"
})(["", " & > span{align-items:baseline;display:inline-flex;pointer-events:none;}& svg{", " padding-right:0.125em;vertical-align:middle;}"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["dib"]))), (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["dib"]))));

exports.StyledDictionaryTerm = StyledDictionaryTerm;

var StyledDictionaryTermContainer = _styledComponents["default"].span.withConfig({
  displayName: "DictionaryTermsstyles__StyledDictionaryTermContainer",
  componentId: "sc-l9zmz5-1"
})(["", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["dib"]))));

exports.StyledDictionaryTermContainer = StyledDictionaryTermContainer;

var StyledDictionaryTermModal = _styledComponents["default"].div.withConfig({
  displayName: "DictionaryTermsstyles__StyledDictionaryTermModal",
  componentId: "sc-l9zmz5-2"
})(["", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["flex-auto h-100 relative"]))));

exports.StyledDictionaryTermModal = StyledDictionaryTermModal;

var StyledDictionaryTermModalContainer = _styledComponents["default"].div.withConfig({
  displayName: "DictionaryTermsstyles__StyledDictionaryTermModalContainer",
  componentId: "sc-l9zmz5-3"
})(["", ""], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    flex flex-wrap flex-nowrap-ns\n  "]))));

exports.StyledDictionaryTermModalContainer = StyledDictionaryTermModalContainer;

var StyledDictionaryTermModalMedia = _styledComponents["default"].div.withConfig({
  displayName: "DictionaryTermsstyles__StyledDictionaryTermModalMedia",
  componentId: "sc-l9zmz5-4"
})(["", ""], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100\n    ", "\n  "])), function (_ref) {
  var hasVideo = _ref.hasVideo;
  return hasVideo ? 'flex-auto w-60-ns' : 'mw4';
}));

exports.StyledDictionaryTermModalMedia = StyledDictionaryTermModalMedia;

var StyledDictionaryTermModalVideo = _styledComponents["default"].div.withConfig({
  displayName: "DictionaryTermsstyles__StyledDictionaryTermModalVideo",
  componentId: "sc-l9zmz5-5"
})(["", " & > div{", "}"], (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["aspect-ratio aspect-ratio--16x9 mb3 mb0-ns bg-light-gray"]))), (0, _ty["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["aspect-ratio--object cover"]))));

exports.StyledDictionaryTermModalVideo = StyledDictionaryTermModalVideo;

var StyledDictionaryTermModalContent = _styledComponents["default"].div.withConfig({
  displayName: "DictionaryTermsstyles__StyledDictionaryTermModalContent",
  componentId: "sc-l9zmz5-6"
})(["", ""], (0, _ty["default"])(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 lh-copy\n    ", "\n    ", "\n  "])), function (_ref2) {
  var hasMedia = _ref2.hasMedia;
  return hasMedia && 'pl3-ns';
}, function (_ref3) {
  var hasVideo = _ref3.hasVideo;
  return hasVideo && 'w-40-ns';
}));

exports.StyledDictionaryTermModalContent = StyledDictionaryTermModalContent;

var StyledDictionaryTermModalTitle = _styledComponents["default"].h2.withConfig({
  displayName: "DictionaryTermsstyles__StyledDictionaryTermModalTitle",
  componentId: "sc-l9zmz5-7"
})(["", ""], (0, _ty["default"])(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n    fw7 f5 f4-ns mb2 lh-title ttc mb2\n    ", "\n  "])), function (_ref4) {
  var hasVideo = _ref4.hasVideo;
  return hasVideo && 'dn db-ns';
}));

exports.StyledDictionaryTermModalTitle = StyledDictionaryTermModalTitle;